import { ChangeDetectionStrategy, Component, input, output, signal, WritableSignal } from '@angular/core';
import { form, FormField } from '@angular/forms/signals';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {
  HANDLED_STRIPE_EVENT_TYPES,
  StripeSubscriptionEventAdminFilterKey,
  ZoudashUtils,
} from '@workspace/data-types';
import {
  AbstractSignalFormComponent,
  DataHeaderFilter,
  FilterChangedDetection,
  FilterRecord,
} from '@workspace/ng-aura';
import { StripeSubscriptionEventColumnKey } from '../abstract-stripe-subscription-events-data-table.component';

export interface StripeSubscriptionEventFilterModel {
  processed: string | string[] | null;
  type: string | string[] | null;
}

@Component({
  selector: 'core-stripe-subscription-events-data-table-filter',
  templateUrl: './stripe-subscription-events-data-table-filter.component.html',
  imports: [FormField, MatFormFieldModule, MatInputModule, MatListModule, MatSlideToggleModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StripeSubscriptionEventsDataTableFilterCoreComponent extends AbstractSignalFormComponent<
  Partial<Record<StripeSubscriptionEventAdminFilterKey, string | string[]>>,
  StripeSubscriptionEventFilterModel
> {
  filterChanged = output<FilterChangedDetection>();
  currentFilterView = input<string | null>(null);
  filters = input.required<DataHeaderFilter<StripeSubscriptionEventColumnKey>[]>();
  processedValues = ['true', 'false'];
  typeValues = [...HANDLED_STRIPE_EVENT_TYPES];
  stripeEventFilterKey = StripeSubscriptionEventAdminFilterKey;

  override model: WritableSignal<StripeSubscriptionEventFilterModel> =
    signal<StripeSubscriptionEventFilterModel>({
      processed: null,
      type: null,
    });

  override formTree = form(this.model);

  override emitDto(newDto: Partial<Record<StripeSubscriptionEventAdminFilterKey, string | string[]>>): void {
    this.filterChanged.emit({
      filter: newDto as FilterRecord,
      changed: !ZoudashUtils.isEqual(newDto, this.ogValue),
    });
  }

  protected override buildModelFromDto(
    dto: Partial<Record<StripeSubscriptionEventAdminFilterKey, string | string[]>>,
  ): StripeSubscriptionEventFilterModel {
    return {
      processed: dto?.processed ?? null,
      type: dto?.type ?? null,
    };
  }

  protected override buildDtoFromModel(
    model: StripeSubscriptionEventFilterModel,
  ): Partial<Record<StripeSubscriptionEventAdminFilterKey, string | string[]>> {
    const dto: Partial<Record<StripeSubscriptionEventAdminFilterKey, string | string[]>> = {
      processed: model.processed ?? undefined,
      type: model.type ?? undefined,
    };
    return Object.fromEntries(Object.entries(dto).filter(([_, v]) => v != null)) as Partial<
      Record<StripeSubscriptionEventAdminFilterKey, string | string[]>
    >;
  }
}
